import React from 'react'
import Icon, { IconName } from '@ui/elements/Icon/Icon'
import { Platform, Pressable } from 'react-native'
import cn from '@ui/utils/cn'

interface Props {
  className?: string
  disabled?: boolean
  onPress?: () => void
  color?: string
  icon: IconName
}

const InputAction = ({ className, disabled, onPress, color, icon }: Props) => (
  <Pressable
    // This behaves weirdly on web and sets the pointer-events to auto on all children
    disabled={Platform.OS != 'web' && disabled}
    onPress={onPress}
    tabIndex={!onPress || disabled ? -1 : 0}
    className={cn(
      'h-12 w-12 items-center justify-center',
      {
        'pointer-events-none': disabled,
      },
      className
    )}
  >
    <Icon name={icon} color={color} />
  </Pressable>
)

export default InputAction
